export default __webpack_public_path__ + "img/g100.32736d54.png";